import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'shared/shared.module';
import { ProfileInfoComponent } from './components/profile-info/profile-info.component';

@NgModule({
  declarations: [ProfileInfoComponent],
  imports: [
    CommonModule,
    SharedModule,
  ],
  exports: [
    ProfileInfoComponent,
  ],
})
export class ProfileInfoModule {
}
